export const getApiErrorMessage = (error, fallback = 'Something went wrong') => {
  const data = error?.response?.data;

  if (data) {
    if (typeof data === 'string') return data;

    // Prefer nested/API errorMessage, then top-level message.
    const errorMessage =
      data.data?.errorMessage || data.errorMessage || data.message || data.error?.message;

    if (typeof errorMessage === 'string' && errorMessage) return errorMessage;
    if (typeof data.error === 'string') return data.error;

    if (Array.isArray(data.errors) && data.errors.length > 0) {
      const first = data.errors[0];
      return typeof first === 'string' ? first : first?.message || fallback;
    }
  }

  if (error?.request && !error?.response) {
    if (error.code === 'ECONNABORTED') {
      return 'Request timed out. Please try again.';
    }

    if (error.code === 'ERR_INVALID_URL') {
      return error.message || 'Invalid API request URL.';
    }

    if (error.message === 'Network Error' || /failed to fetch/i.test(String(error.message || ''))) {
      return 'No internet connection. Please check your network and try again.';
    }

    return error.message || 'Unable to reach the server. Please try again.';
  }

  if (error?.code === 'ERR_INVALID_URL') {
    return error.message || 'Invalid API request URL.';
  }

  return error?.message || fallback;
};

/** 400 responses from GHL endpoints are expected (e.g. location not provisioned) and are not shown to users. */
export const isGhlBadRequest = (error) =>
  error?.response?.status === 400 && /\/ghl\//.test(String(error?.config?.url || ''));

export default getApiErrorMessage;
